<template>
  <div class="d-flex flex-column">
    <!-- UPLOAD -->
    <template v-if="files.length < maxFileCount">
      <input
        type="file"
        ref="actualFileInput"
        class="d-none"
        @change="uploadBrowsedFiles()"
        multiple
        :accept="audio ? 'audio/*' : 'video/*,image/*,application/*,text/*,multipart/*'"
      />
      <div
        class="file-upload"
        @click="chooseFile()"
        @dragover="(e) => onDragover(e)"
        @dragleave="(e) => onDragLeave(e)"
        @drop="(e) => uploadDroppedFile(e)"
      >
        <div class="banner">
          <b-icon-cloud-arrow-up class="upload-icon" />
          <span class="prompt">Перетащите файлы сюда или нажмите, чтобы открыть диалог загрузки</span>
        </div>
      </div>
    </template>

    <div v-if="files.length && files.length < maxFileCount" class="mb-3" />
    <file-tree v-model="files" :audio="audio" @change="broadcastChanges()" />
  </div>
</template>

<style lang="scss" scoped>
.file-upload {
  cursor: pointer;
  width: 100%;
  height: 300px;
  border: 2px dashed #adadad;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.drag-over {
    background-color: #eee;
    border-color: #3699ff;
  }
  .banner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    pointer-events: none;
    .upload-icon {
      width: 100px;
      height: 100px;
      color: #e0e0e0;
    }
    .prompt {
      font-size: 1rem;
      font-weight: 500;
      max-width: 250px;
      text-align: center;
      color: #3f4254;
    }
  }
}

.file {
  background-color: #f3f6f9;
  color: #3f4254;
  .name {
    font-weight: 400;
    color: #3699ff;
    &:hover {
      color: #3f4254;
    }
  }
  .remove {
    color: #3f4254;
    &:hover {
      color: #3699ff;
    }
  }
}

.remove {
  cursor: pointer;
}
</style>

<script>
import Api from "shared/service/api/api";
import { PREVENT_UNLOAD, ALLOW_UNLOAD } from "shared/store/modules/beforeunload.store.js";
import { BIconX, BIconCloudArrowUp } from "bootstrap-vue";
import FileTree from "shared/widgets/tree/FileTree.vue";

export default {
  name: "FileUploader",
  components: { BIconX, BIconCloudArrowUp, FileTree },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    maxFileCount: {
      type: Number,
      required: false,
      default: 1,
    },
    audio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: this.value,
    };
  },
  methods: {
    chooseFile() {
      this.$refs.actualFileInput.click();
    },
    uploadBrowsedFiles() {
      this.$refs.actualFileInput.files.length && [...this.$refs.actualFileInput.files].forEach((f) => this.upload(f));
    },
    upload(file) {
      /* if (~file.type.indexOf('audio/')) {
        if (!this.audio) {
          this.$alert.error("Нельзя загрузить аудио файл в этом блоке!");
          return;
        }
      } else {
        if (this.audio) {
          this.$alert.error("В этом блоке можно загружать только аудио файлы!");
          return;
        }
      } */

      const fileId = "uploading_" + Date.now() + Math.random() + file.name;

      this.files = this.files.sort((a, b) => a.weight - b.weight);
      const maxWeight = this.files.length ? this.files[this.files.length - 1].weight : undefined;
      const weight = maxWeight ? maxWeight + 10 : 10;
      this.files.push({
        id: fileId,
        name: file.name,
        url: "",
        weight: weight,
      });

      this.$store.dispatch(PREVENT_UNLOAD);
      Api.multimedia.file
        .upload(file)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.files = this.files.map((f) => (f.id === fileId ? { ...f, ...response.data } : f));
          this.$forceUpdate();
          this.broadcastChanges();
        })
        .catch((e) => {
          this.$alert.error("Ошибка загрузки файла.<br>" + e.message);
          this.files = this.files.filter((f) => f.id !== fileId);
        })
        .finally(() => {
          this.$store.dispatch(ALLOW_UNLOAD);
        });
    },
    remove(id) {
      this.files = this.files.filter((i) => i.id !== id);
      this.broadcastChanges();
    },
    onDragover(e) {
      e.target.classList.add("drag-over");
    },
    onDragLeave(e) {
      e.target.classList.remove("drag-over");
    },
    uploadDroppedFile(e) {
      this.onDragLeave(e);
      e.preventDefault();

      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          const item = e.dataTransfer.items[i];
          item.kind === "file" && this.upload(item.getAsFile());
        }
      } else {
        this.$alert.error("Ошибка. Свяжитесь с разработчиками.");
      }
    },
    broadcastChanges() {
      this.$emit("input", this.files);
      this.$emit("change");
    },
  },
};
</script>
